// import "./App.css";
import React from "react";
import Layout from "./pages/Layout";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import MemberFormPage from "./pages/MemberFormPage";
import MemberAdminPage from "./pages/MemberAdminPage";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<MemberFormPage />} />
          <Route path="membri-admin" element={<MemberAdminPage />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
